export default function highlightTermsAndConditions() {
    $('.acceptTermsMessage').removeClass('d-none');

    // Animate the T & C container
    const $termsContainer = $('.acceptTermsFormGroup');
    $termsContainer.removeClass('animate');
    void $termsContainer[0].offsetWidth;
    $termsContainer.addClass('animate');

    // Scroll user to the T & C
    $('html, body').animate({
        scrollTop: $('#accept_terms').offset().top - 300
    }, 0);

    // Disable the Adyen pay button
    $('.adyen-checkout__button--pay').addClass('disabled');
}